// extracted by mini-css-extract-plugin
export default {"Container":"TopCategorits_Container__y912S"};